export const getValidSteps = (level, steps, origWidth) => {
  const popupWidth = window.innerWidth;
  let validSteps = steps;
  if (origWidth) {
    // Test how much zoom can actually be done without losing quality
    while (Math.pow(level, validSteps) * popupWidth > origWidth && validSteps > 0) {
      validSteps--;
    }
  } else {
    console.warn('Could not retrieve original image dimensions');
  }

  return validSteps;
};
